export default __webpack_public_path__ + "static/media/back_rand3.35efc61c.jpg";